<script>
  export let currentRoutePath = null;
  export let config = null;

  currentRoutePath, config;
</script>

<slot />
